<template>
    <div class="size-color mt-4 mt-4 call-or-buy position-relative" v-if="check">
        <label :class="{
            'mb-0': true,
            'input-on-alue': true,
            'position-absolute' : true,
            'buy-call' : true
        }">Màu sắc - Kích thước</label>
        <div class="d-flex position-relative">
            <!-- <ldc-select
                v-model="color"
                placeholder="Chọn màu sắc"
                class="rv-select-form mr-2">
                <ldc-option
                    :value="0"
                    label="Xanh"/>
                <ldc-option
                    :value="1"
                    label="Đỏ"/>
            </ldc-select>
            <ldc-select
                v-model="selectSize"
                placeholder="Chọn Size"
                class="rv-select-form">
                <ldc-option v-for="(item, key) in size" :key="key"
                    :value="item"
                    :label="item.name"/>
            </ldc-select> -->
        </div>
        <div class="table">
            <div class="tr-color" v-for="(item, key) in items" :key="key">
                <div class="tr d-flex">
                    <div class="pro-m text-left"> 
                        <ldc-select
                            v-model="items[key].color"
                            placeholder="Màu sắc"
                            class="mr-2 product-select">
                            <ldc-option v-for="(item, key) in color" :key="key"
                                :value="item.id"
                                :label="item.name"/>
                        </ldc-select>
                    </div>
                    <div class="sz-pro text-center">
                        <ldc-select
                            v-model="items[key].size"
                            placeholder="Size"
                            class="mr-2 product-select">
                            <ldc-option v-for="(item, key) in size" :key="key"
                                :value="item.id"
                                :label="item.name"/>
                        </ldc-select>
                    </div>
                    <div class="inpt-price">
                        <input type="text" class="input-price-size-color mr-1 text-right w-100 szc-price"
                                v-model="items[key].price" ref="input-action-dialog" @input="formatPrice(key)" placeholder="Giá" 
                                @focus="(e) => e.target.select()"/>
                    </div>
                    <div class="inpt-number ml-3">
                         <input type="text" class="input-price-size-color mr-1 text-right w-100" 
                                v-model="items[key].quantity" ref="input-action-dialog" @input="formatQuantity(key)" placeholder="Số lượng" 
                                @focus="(e) => e.target.select()"/>
                    </div>
                    <div class="btn-delete text-right"  @click="del(key)"><i class="icon ion-md-trash"></i></div>
                </div>
                <div class="text-center fixed-bottom position-absolute w-100 plus-szcl" v-if="key == 0">
                    <div class="plus-size-color" @click="plus(items.length-1)">
                         <i class="icon ion-md-add"></i>
                    </div>
                </div>
            </div>

        </div>
        <!-- <div class="text-danger fs-12px mt-1" >sdsdsdsds</div> -->
    </div>
</template>
<script>
export default {
    props: ['data', 'error','sizecolor'],
    data() {
        return {
            i : 2,
            items: [],
            price : '',
            color : [],
            size : [],
            selectSize : [],
            selectColor : [],
            select : [],
            check : false,
        }
    },
    watch: {
        data(val){
            this.items = this.data;
        },
        items(val){
            this.$emit('update:data', val);
        },
        sizecolor(val){
            this.color = val.color;
            this.size = val.size; 
            if(this.sizecolor && this.sizecolor.size.length > 0 || this.items && this.items.length > 0){
                this.check = true;
            }else{
                this.check = false;
            }
        },
        selectSize(val){
            if(this.select && this.select['color']){
            
            }else{
                let arr = []; 
                arr.push({
                    size    :   val, // id size
                    color :     val.id, // id color
                    price :     null, // giá
                    quantity :  null, // số lượng
                    picture     :   null
                });
            }

        }
    },
    created() {
        this.items = this.data;
        this.items.map(item => {
            item.price = this.$formatNumber(item.price);
        })
        this.pushItem();
        if(this.sizecolor && this.sizecolor.size && this.sizecolor.size.length > 0 || this.items && this.items.length > 0){
            this.check = true;
        }
    },
    mounted(){
        this.color = this.sizecolor.color;
        this.size = this.sizecolor.size; 
    },
    methods: {
        formatPrice(key){
            this.items[key].price = this.items[key].price.replace(/[^0-9]/g, '');
            this.items[key].price = this.$formatNumber(this.items[key].price);
        },
        formatQuantity(key){
            this.items[key].quantity = this.items[key].quantity.replace(/[^0-9]/g, '');
        },
        plus(key){
            let data = this.items;

            if(data[key].color != null && data[key].size != null && data[key].price != null && data[key].quantity != null){
                this.items.push({
                    color : null,
                    size : null,
                    price : null,
                    quantity  : null,
                    picture : 0
                })
            }else{
                this.$message({
                    message: 'Nhập đầy đủ thông tin trong form Màu sắc - Kích thước',
                    type: 'warning',
                    center: true,
                });
            }
        },
        del(key){
            if(this.items[key].pscd_psci_id){
                apiPost(`v2/products/delete_size_color`,  {
                        psci_id: this.items[key].pscd_psci_id,
                        iCat : this.items[key].cat_id,
                    }).then(res => {
                    console.log('Xóa ảnh thành công!')
                }).catch(err => {
                    console.warning('Lỗi hê thống!')
                });
            }
            this.items.splice(key,1);
            if(this.items.length == 0){
                this.items.push({
                    color : null,
                    size : null,
                    price : null,
                    quantity  : null,
                    picture : 0
                })
            }
        },
        pushItem(){
            this.items.push({
                color : null,
                size : null,
                price : null,
                quantity  : null,
                picture : 0
            })
        }
    }
};
</script>
<style lang='scss'>
    .input-price-size-color{
        border-bottom: 1px solid #ccc;
        border-top: none;
        border-right: none;
        outline: none;
        border-left: none;
    }
    .pro-m{
        width: 25%;
    }
    .sz-pro{
       width: 20%;
    }
    .inpt-number{
        width: 15%;
    }
    .inpt-price{
        width: 35%;
        .szc-price{
            color: #f44f00;
        }
    }
    .btn-delete{
        width: 5%;
    }
    .plus-szcl{
        bottom: -5px !important;
    }
    .tr-color{
        padding: 7px 0px;
    }
    .product-select{
        .ldc-input-select{
            position: relative;
            .ldc-input{
                padding: 0!important;
                border-bottom: 1px solid rgba(0, 0, 0, 0.2)!important;
                border-top: none!important;
                border-right: none!important;
                color: #000;
                font-size: 16px !important;
                height: unset !important;
                line-height: unset !important;
                border-left: none!important;
            }
            svg{
                right: 0!important;
            }
        }
    }
    .plus-size-color{
        width: 30px;
        margin: 0 auto;
        background: #007bff;
        border-radius: 50%;
        height: 30px;
        line-height: 30px;
        color: white;
        margin-top: 5px;
    }
</style>
